import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Logo } from "./Logo";
import { CONTACT } from "./Booking";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#070708] border-t border-white/5 pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div className="flex items-center gap-4"><Logo className="h-14 w-14" />
            <p className="max-w-xs text-sm text-zinc-400">{t.hero.sub.split(".")[0]}.</p>
          </div>
          <div className="flex flex-col gap-2 text-sm text-zinc-300 md:text-right">
            <a href={CONTACT.emailHref} className="link-underline w-fit md:ml-auto">{CONTACT.email}</a>
            <a href={CONTACT.phoneHref} className="link-underline w-fit md:ml-auto">{CONTACT.phone}</a>
          </div>
        </div>
        <p className="mt-16 font-display font-light leading-[0.85] tracking-[-0.04em] text-[11.5vw] text-transparent [-webkit-text-stroke:1px_rgba(197,160,89,0.4)] select-none whitespace-nowrap" aria-hidden="true">
          Turismo da Capital
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-zinc-400 tracking-wider">
          <span>© {year} Turismo da Capital. {t.footer.rights}</span>
          <Link to="/admin/login" className="hover:text-[#C5A059] transition-colors" data-testid="footer-admin-link">{t.footer.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
